import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Trophy, Star, Medal, Crown } from 'lucide-react';
import Footer from '../components/Footer';
import PrizeLottie from '../components/PrizeLottie';

const prizes = [
  {
    icon: Trophy,
    title: "Primer Premio",
    description: "Lote de Navidad Premium",
    image: "https://cdn.metro-group.com/es/es_pim_219136001001_02.png",
    details: [
      "Este lote de Navidad contiene:",
      "Bebidas:",
      "1 Botella 75 cl Cava Brut Vintage Canals Nubiola",
      "2 Botella 75 cl Vino tinto crianza D.O.Ca. Rioja Cune",
      "1 Botella 75 cl Vino Blanco Semidulce Goleta Azul Rueda",
      "1 Botella Ginebra Premium The Botanical´s Premium London Dry Gin 70 cl 42,5%",
      "Charcutería:",
      "1 Estuche 325g aprox. Chorizo ibérico bellota La Barrica",
      "1 Estuche 325g aprox. salchichón ibérico bellota La Barrica",
      "1 Estuche 80g. Jamón ibérico cebo 50% loncheado Sanchez Alcaraz",
      "1 Pieza 180g. Aprox. Fuet ibérico extra Sierra de Azuaga",
      "1 Estuche 325g. Aprox. Lomo embuchado gran selección España",
      "1 Cuña de queso 250g. Reserva Albéniz",
      "Conservas y Otros:",
      "1 Lata 130 G. LCde Pate de Pato Martiko Superior",
      "1 Lata 150 g.n.e aceitunas rellenas de anchoa Excelencia",
      "1 Bolsa 150 g nuez imperial Itac",
      "1 Estuche 100 g cocktail selección frutos secos Itac",
      "1 Botella cristal 250ml. Aceite de oliva virgen extra Capricho Andaluz",
      "1 Lata 50 GNE Gula del norte al ajillo UBAGO",
      "Turrones y Dulces:",
      "1 Tableta 150g. Turrón Alicante Extra Picó",
      "1 Tableta 150g. Turrón jijona Extra Picó",
      "1 Estuche 90g. Pasas Moscatel Sybarites",
      "1 Estuche 100g. Biscuits de Vainilla Dulcestepa",
      "1 Estuche 70 gr hojaldre nevado E. Moreno",
      "1 Estuche 100 g. palmeritas hojaldre S. Aubert",
      "1 Estuche 150 g surtido mantecados Antaño",
      "1 Tableta 150g. Turrón pistacho Suprema TURRON 25",
      "1 Tarro 250g.n miel natural de Azahar Anae",
      "1 Frasco 160 gr. Cereza Roja en almíbar HELIOS",
      "1 Pack Gourmet Helios 45 gr. (Tomate, Cebolla y Pimiento)"
    ]
  },
  {
    icon: Medal,
    title: "Segundo Premio",
    description: "Tarjeta Regalo El Corte Inglés",
    image: "https://cdn.grupoelcorteingles.es/SGFM/dctm/MEDIA03/202312/12/00179915400018____4__1200x1200.jpg",
    details: [
      "Tarjeta regalo por valor de 75€",
      "Válida en todas las tiendas El Corte Inglés",
      "Utilizable en cualquier departamento",
      "1 año de validez"
    ]
  },
  {
    icon: Star,
    title: "Tercer Premio",
    description: "Tarjeta Regalo TodoJuguete",
    image: "https://i.imgur.com/R7vk914.png",
    details: [
      "Tarjeta regalo por valor de 40€",
      "Válida en TodoJuguete.es",
      "Para compras online",
      "6 meses de validez"
    ]
  }
];

export default function Prizes() {
  return (
    <>
      <Helmet>
        <title>Premios del Concurso - Concurso de Árboles de Navidad</title>
        <meta 
          name="description" 
          content="Descubre los increíbles premios que puedes ganar en nuestro concurso de árboles de Navidad." 
        />
        <link rel="canonical" href="https://arbolnavidad.com/premios" />
      </Helmet>

      <div className="min-h-screen pt-16">
        <div className="bg-primary text-white py-8">
          <div className="container mx-auto px-4 text-center">
            <PrizeLottie className="mb-2" />
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Premios Increíbles</h1>
            <p className="text-xl text-gray-200 max-w-2xl mx-auto">
              Los mejores árboles serán recompensados con premios espectaculares
            </p>
          </div>
        </div>

        <div className="bg-secondary-light py-20">
          <div className="container mx-auto px-4">
            <div className="grid md:grid-cols-3 gap-8">
              {prizes.map((prize, index) => {
                const Icon = prize.icon;
                return (
                  <div 
                    key={index}
                    className="bg-white p-8 rounded-xl shadow-ofertium hover:shadow-lg transition-shadow"
                  >
                    <div className="text-center mb-6">
                      <Icon className="h-16 w-16 mx-auto text-primary mb-4" />
                      <h3 className="text-2xl font-bold text-primary mb-2">{prize.title}</h3>
                      <p className="text-gray-600">{prize.description}</p>
                    </div>
                    {prize.image && (
                      <div className="mb-6">
                        <img 
                          src={prize.image} 
                          alt={prize.title}
                          className="w-full h-auto rounded-lg shadow-sm"
                        />
                      </div>
                    )}
                    <ul className="space-y-3">
                      {prize.details.map((detail, i) => (
                        <li key={i} className="flex items-center text-gray-700">
                          <Star className="h-4 w-4 text-secondary mr-2 flex-shrink-0" />
                          <span>{detail}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div className="bg-white py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-3xl font-bold text-primary mb-8 text-center">
                Información Importante
              </h2>
              
              <div className="space-y-6">
                <div className="bg-secondary-light p-6 rounded-xl">
                  <h3 className="text-xl font-bold text-primary mb-4">
                    Entrega de Premios
                  </h3>
                  <ul className="space-y-3 text-gray-700">
                    <li className="flex items-start">
                      <Crown className="h-5 w-5 text-primary mr-2 mt-1" />
                      <span>Se anunciará el ganador el 26 de diciembre</span>
                    </li>
                    <li className="flex items-start">
                      <Crown className="h-5 w-5 text-primary mr-2 mt-1" />
                      <span>Los premios no son transferibles ni canjeables por dinero</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-secondary-light p-6 rounded-xl">
                  <h3 className="text-xl font-bold text-primary mb-4">
                    Requisitos
                  </h3>
                  <ul className="space-y-3 text-gray-700">
                    <li className="flex items-start">
                      <Crown className="h-5 w-5 text-primary mr-2 mt-1" />
                      <span>Ser mayor de 18 años</span>
                    </li>
                    <li className="flex items-start">
                      <Crown className="h-5 w-5 text-primary mr-2 mt-1" />
                      <span>Residir en España peninsular</span>
                    </li>
                    <li className="flex items-start">
                      <Crown className="h-5 w-5 text-primary mr-2 mt-1" />
                      <span>Presentar DNI al recoger el premio</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}